import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import { StatusBadge } from "@/components/StatusBadge";

export default function Archives() {
  const { t } = useI18n();
  const [protocols, setProtocols] = useState([]);

  useEffect(() => {
    api.get("/protocoles", { params: { statut: "OBSOLETE" } }).then((res) => setProtocols(res.data));
  }, []);

  return (
    <div className="p-4 md:p-6 space-y-4" data-testid="archives-view">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">{t("nav.archives")}</h1>
      {protocols.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="archives-empty">
          {t("common.no_results")}
        </p>
      ) : (
        <div className="space-y-2">
          {protocols.map((p) => (
            <Link
              key={p.Protocol_ID}
              to={`/protocole/${p.Protocol_ID}`}
              className="block bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-4 hover:border-slate-400 dark:hover:border-slate-600 transition-colors"
              data-testid={`archive-row-${p.Protocol_ID}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-mono text-xs text-slate-500">
                    {p.Protocol_ID} · v{p.Version_Courante}
                  </p>
                  <p className="font-semibold text-slate-800 dark:text-slate-200">{p.Titre}</p>
                </div>
                <StatusBadge status={p.Statut} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
